import { GenerateAspEmbedUrlRequest, GenerateAspEmbedUrlResponse } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useGenerateAspEmbedUrl() {
  const [fetching, setFetching] = useState(false);
  const [embedUrl, setEmbedUrl] = useState<string>();

  async function generateAspEmbedUrl(params: GenerateAspEmbedUrlRequest = {}): Promise<GenerateAspEmbedUrlResponse> {
    try {
      setFetching(true);
      const res = await api.generateAspEmbedUrl(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setEmbedUrl(res.Link);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, embedUrl, generateAspEmbedUrl };
}
